// #region Imports
import { defineComponent } from "vue";
// #endregion
// #region Core
export default defineComponent({
    // #region Class
    name: 'g-catalog-page',
    // #endregion
    // #region Data
    data: () => ({
        catalog: {},
    }),
    // #endregion
    // #region Constructor
    created() {
        this.loadCatalog();
    },
    mounted() {
        this.selectCategory();
    },
    // #endregion
    // #region computed
    computed: {
        catalogID() {
            return this.$route.params.catalogID;
        },
        categoryID() {
            return this.$route.params.categoryID;
        },
    },
    // #endregion
    // #region Watch
    watch: {
        "$route.params.catalogID"(value) {
            this.loadCatalog();
        },
        "$route.params.categoryID"(value) {
            this.selectCategory();
        },
    },
    // #endregion
    // #region Methods
    methods: {
        loadCatalog() {
            if (utils.isNullOrEmpty(this.catalogID)) {
                return;
            }
            host.api.get(`commerce/catalog/${this.catalogID}`)
                .then((e) => {
                if (e.status === 204) {
                    return;
                }
                if (!e.data) {
                    return;
                }
                //Breadcrumb
                this.$store.commit('navigation/setBreadcrumb', e.data.breadcrumb);
                //Catalog
                this.catalog = e.data;
                //Category
                this.selectCategory();
            })
                .catch((e) => {
                host.notification.showToast(utils.getAxiosErrorMessage(e));
            });
        },
        filterItems(nodes, parentID) {
            if (!nodes) {
                return [];
            }
            return nodes.filter(e => e.parentID === parentID);
        },
        selectCategory() {
            if (utils.isNullOrEmpty(this.categoryID)) {
                return;
            }
            if (!this.catalog) {
                return;
            }
            if (!this.catalog.categories) {
                return;
            }
            this.catalog.categories.forEach((e) => {
                if ((e.categoryID?.toLowerCase() == this.categoryID?.toLowerCase()) || (e.name?.toLowerCase() == this.categoryID?.toLowerCase())) {
                    e.isSelected = true;
                }
                else {
                    e.isSelected = false;
                }
            });
            this.catalog.categories.forEach((e) => {
                if (e.isExpanded) {
                    return;
                }
                e.isExpanded = this.hasSelectedChildNode(this.catalog.categories, e.categoryID);
            });
        },
        hasSelectedChildNode(nodes, categoryID) {
            for (let i = 0; i < nodes.length; i++) {
                //Find
                let tItem = nodes[i];
                //Check
                if (tItem.parentID !== categoryID) {
                    continue;
                }
                //Selected
                if (tItem.isSelected) {
                    return true;
                }
                if (this.hasSelectedChildNode(nodes, tItem.categoryID)) {
                    return true;
                }
            }
            return false;
        },
        selectItem(e) {
            if (e.node.children !== undefined && e.node.children.length > 0) {
                if (!e.node.expanded) {
                    e.component.expandItem(e.node.key);
                }
                else {
                    e.component.collapseItem(e.node.key);
                }
            }
            else {
                //e.itemData.isSelected = true;                    
                this.$router.push(e.itemData.address);
            }
        },
        OnRefresh(event) {
            //Default
            event.preventDefault();
            //Notify
            this.$host.eventBus.emit('refresh');
        }
    },
    // #endregion
});
// #endregion
